export default (d) => d;
//# sourceMappingURL=identity.js.map